export default {
  API_APP:{
    id:'0z3ilCaAFQJ7Z6u4SHEpewFR3WUjzztMxSgRQX5D',
    secret:'DJdEQOJxXTzEK3SFuFjCIgrxoJkdr4IrcQEmncBjkuFiYaJ7CqI4wKjjlXFKdyow6pqkvu3ugAXIW1aq67WBO2HiJYXPhQ9P5UXswj17ECBTvuMBs4twEam4B6y5WSzj',
  },
}



// WEBPACK FOOTER //
// ./src/App/config/credential.js